export default {
  default: () => import("/builds/bazinga/pharmasuisse/frontend/layouts/default.vue"),
  print: () => import("/builds/bazinga/pharmasuisse/frontend/layouts/print.vue")
}